export const libCust = {
	CUS1_49: "Call Time",
	CUS1_47: "Please Wait Until Your Queue Number is Called",
	CUS1_48: "Called at",
	CUS1_45: "Waiting Duration",
	CUS1_46: "Copy",
	CUS1_43: "in Queue",
	CUS1_44: "Check-In Time",
	CUS1_41: "Last Called",
	CUS1_42: "Waiting",
	CUS1_40:
		"Your Booking is Successful, Please Check-In at the Location between %s - %s on the Booking Date",
	CUS1_38: "Check In",
	CUS1_39: "Share",
	CUS1_36: "Booking Time",
	CUS1_37: "Download",
	CUS1_34: "Booking Date",
	CUS1_35: "Printed Date",
	CUS1_32: "Service Type",
	CUS1_33: "Your Booking Code",
	CUS1_30: "Cancel",
	CUS1_31: "Your queue number",
	CUS1_72: "Postponed at",
	CUS1_70: "Served at",
	CUS1_71: "Estimated Waiting Time",
	CUS1_7: "Don't have an account?",
	CUS1_29: "Submit",
	CUS1_8: "Sign up",
	CUS1_9: "or",
	CUS1_27: "Enter WhatsApp number",
	CUS1_28: "Enter captcha",
	CUS1_25: "Time",
	CUS1_69: "Resend Code",
	CUS1_26: "WhatsApp Number",
	CUS1_23: "Booking Details",
	CUS1_67: "Enter the verification code sent to your WhatsApp account.",
	CUS1_24: "Date",
	CUS1_68: "Verify",
	CUS1_1:
		"Input Whatsapp number and Password to start using ique cloud service",
	CUS1_2: "Input whatsapp number",
	CUS1_3: "Input password",
	CUS1_4: "Forgot password?",
	CUS1_5: "Log in",
	CUS1_6: "Don't have an account? Register",
	CUS1_21: "Remaining Queue",
	CUS1_65: "to register using the iQue Cloud service.",
	CUS1_22: "Back",
	CUS1_66: "Already have an account?",
	CUS1_63: "Submit",
	CUS1_20: "Select Sub Service",
	CUS1_64: "Enter your WhatsApp number",
	CUS1_61: "to reset your iQue Cloud account",
	CUS1_62: "Enter your WhatsApp number",
	CUS1_60: "Booking Cancelled",
	CUS1_18: "Select Tenant",
	CUS1_19: "Select Service",
	CUS1_16: "Home",
	CUS1_17: "Guest",
	CUS1_14: "City",
	CUS1_58: "Your Queue Number Has Been Called",
	CUS1_15: "Select Category",
	CUS1_59: "Queue Postponed, Please Wait Until Your Queue Number Is Called",
	CUS1_12: "to start using the iQue Cloud service",
	CUS1_56: "End Time",
	CUS1_13: "Province",
	CUS1_57: "Thank you for your feedback.",
	CUS1_10: "Login as guest",
	CUS1_54: "Write your comment here",
	CUS1_11: "Enter your WhatsApp number and password",
	CUS1_55: "Save Feedback",
	CUS1_52: "Service Duration",
	CUS1_53: "Service Completed. Please Provide Your Feedback",
	CUS1_50: "Your Queue is Being Served",
	CUS1_51: "Start Time",
};

export const libAdmin = {
	CON1_25: "Tambah kategori",
	CON1_24: "Rows per page",
	CON1_23: "Aksi",
	CON1_22: "Logo",
	CON1_29: "Batal",
	CON1_28: "No file choosen",
	CON1_27: "Choose file",
	CON1_26: "Nama kategori",
	CON1_120: "Tambah Jadwal Layanan Non Aktif Sementara",
	CON1_241: "Detail Pengguna",
	CON1_362: "Download panduan parameter kepuasan",
	CON1_240: "Hapus",
	CON1_361: "Download panduan parameter video",
	CON1_360: "Parameter Hari Libur",
	CON1_113: "Cetak QR",
	CON1_234: "Tambah Pengguna",
	CON1_355: "Download panduan produk dan suku bunga",
	CON1_112: "Show sisa Antrian",
	CON1_233: "Ubah Template Tema",
	CON1_354: "Download master user layanan",
	CON1_111: "Show on Kiosk",
	CON1_232: "Sidebar",
	CON1_353: "Download panduan master loket",
	CON1_110: "Show on web",
	CON1_231: "Label Title",
	CON1_352: "Download panduan master loket layanan cabang",
	CON1_117: "Master Layanan Non Aktif",
	CON1_238: "Role",
	CON1_359: "Download panduan parameter hari libur",
	CON1_116: "Nomor Telephone",
	CON1_237: "Password",
	CON1_358: "Download panduan parameter banner/image",
	CON1_115: "Ubah Layanan",
	CON1_236: "Nama Pengguna",
	CON1_357: "Master Valas",
	CON1_114: "Tombol Finish",
	CON1_235: "Nama Lengkap",
	CON1_356: "Download panduan valas",
	CON1_119: "Tanggal Akhir",
	CON1_118: "Tanggal Mulai",
	CON1_239: "Ubah",
	CON1_21: "Nama",
	CON1_20: "No.",
	CON1_14: "Laporan",
	CON1_13: "Reset Antrian",
	CON1_12: "Parameter",
	CON1_11: "Master Tenant",
	CON1_18: "Cari",
	CON1_17: "Tambah data",
	CON1_16: "Pengguna",
	CON1_15: "Tema",
	CON1_19: "Ketik disini lalu tekan cari",
	CON1_230: "Label Terlewat title",
	CON1_351: "Download panduan master layanan non aktif",
	CON1_350: "Download panduan master display",
	CON1_102: "Wa booking",
	CON1_223: "Label Running Text",
	CON1_344: "Download panduan semua menu",
	CON1_101: "Jumlah print",
	CON1_222: "Label Antrian",
	CON1_343: "Cabang harus dipilih",
	CON1_100: "Kode Layanan",
	CON1_221: "Background Antrian",
	CON1_342: "Status harus dipilih.",
	CON1_220: "Label Counter",
	CON1_341: "Role harus dipilih.",
	CON1_106: "Jenis Layanan",
	CON1_227: "Background Antrian Terlewat",
	CON1_348: "Download panduan dashboard",
	CON1_105: "Wa Pemanggilan setelah hold",
	CON1_226: "Big Display",
	CON1_347: "Halaman Login",
	CON1_104: "Wa Pemanggilan Pertama",
	CON1_225: "Label Antrian Last",
	CON1_346: "Download panduan halaman login",
	CON1_103: "Tidak Aktif",
	CON1_224: "Background Antrian Last",
	CON1_345: "Panduan semua menu",
	CON1_109: "Pemanggil Acak",
	CON1_108: "Foto Customer",
	CON1_229: "Background Terlewat title",
	CON1_107: "Field Eform",
	CON1_228: "Label Antrian Terlewat",
	CON1_349: "Download panduan master cabang",
	CON1_10: "Kategori tenant",
	CON1_340: "Password harus diisi.",
	CON1_212: "Color Running Text",
	CON1_333: "Alasan Penilaian harus diisi.",
	CON1_211: "Background running text",
	CON1_332: "Kategori harus dipilih.",
	CON1_210: "Font 3",
	CON1_331: "File wajib diisi.",
	CON1_330: "Nama video harus diisi maksimal 50 karakter.",
	CON1_337: "Deskripsi harus diisi.",
	CON1_216: "Display 2",
	CON1_215: "Background Pemanggilan",
	CON1_336: "Apakah anda yakin ingin menghapus data kepuasan tersebut?",
	CON1_214: "Teks Pemanggilan",
	CON1_335: "Hapus Kepuasan",
	CON1_213: "Background Title Antrian",
	CON1_334: "Bintang harus dipilih.",
	CON1_219: "Background Counter",
	CON1_218: "Label Waktu",
	CON1_339: "Username tidak valid: minimal 7 karakter tanpa spasi.",
	CON1_217: "Background Utama",
	CON1_338: "Nama lengkap harus diisi minimal 3 karakter.",
	CON1_201: "Global",
	CON1_322: "Apakah anda yakin ingin menghapus valas tersebut?",
	CON1_200: "Nama Tema",
	CON1_321: "Hapus Valas",
	CON1_320: "Beli harus diisi",
	CON1_205: "Antrian",
	CON1_326:
		"Nama banner harus diisi minimal 10 karakter dan maksimal 50 karakter.",
	CON1_204: "Background",
	CON1_325:
		"Isi running text harus diisi minimal 10 karakter dan maksimal 50 karakter.",
	CON1_203: "Display 1",
	CON1_324: "Tambah Data Valas",
	CON1_202: "Warna",
	CON1_323: "Ubah Valas",
	CON1_209: "Font 2",
	CON1_208: "Font 1",
	CON1_329: "Apakah anda yakin ingin menghapus video tersebut?",
	CON1_207: "Waktu",
	CON1_328: "Hapus Video",
	CON1_206: "Dilayani",
	CON1_327: "Apakah anda yakin akan mengubah data tersebut?",
	CON1_69: "Ubah Jadwal",
	CON1_68: "Hari/Jam",
	CON1_67: "Batas Maksimal Layanan Perjam",
	CON1_66: "Tutup",
	CON1_311: "Konfirmasi Hapus Produk Item",
	CON1_310: "Ubah Produk Item",
	CON1_315: "Persentase harus diisi.",
	CON1_314: "Nama Produk harus diisi.",
	CON1_313: "Ya, Hapus",
	CON1_312: "Apakah Anda yakin ingin menghapus produk item ini?",
	CON1_319: "Jual harus diisi",
	CON1_61: "Layanan cabang",
	CON1_318:
		"Apakah Anda yakin ingin menghapus produk ini beserta item terkaitnya?",
	CON1_60: "Jadwal",
	CON1_317: "Konfirmasi Hapus Produk",
	CON1_316: "Nama produk item harus diisi",
	CON1_65: "Layanan",
	CON1_64: "List cabang",
	CON1_63: "Buka, Tutup",
	CON1_62: "Ubah Jadwal Cabang",
	CON1_58: "Limit display",
	CON1_57: "Limit Loket",
	CON1_56: "Desa (ketik 3 karakter)",
	CON1_55: "Nama Cabang",
	CON1_59: "API Key Cabang",
	CON1_300: "Nama sub layanan harus diisi.",
	CON1_304: "Pilih loket",
	CON1_303: "Jumlah print harus diisi.",
	CON1_302: "Kode layanan harus diisi.",
	CON1_301: "SLA harus diisi.",
	CON1_308: "Tambah Produk",
	CON1_50: "Kiosk",
	CON1_307: "Ubah Produk",
	CON1_306: "Belum ada produk ditambahkan",
	CON1_305: "Navigasi",
	CON1_54: "Tambah Cabang",
	CON1_53: "Url Monitoring",
	CON1_52: "Zona Waktu",
	CON1_309: "Tambah Produk Item",
	CON1_51: "Kategori",
	CON1_47: "Master Cabang",
	CON1_46: "Tambah tenant",
	CON1_45: "Non-Aktif",
	CON1_44: "Virtual tiket via whatsapp",
	CON1_49: "Alamat",
	CON1_48: "No",
	CON1_43: "Aktif",
	CON1_42: "Auto serve",
	CON1_41: "Delay auto serve (detik)",
	CON1_40: "Nama Tenant",
	CON1_36: "Loket Layanan Cabang",
	CON1_35: "User Layanan",
	CON1_34: "Layanan Non Aktif",
	CON1_33: "Display",
	CON1_39: "Ubah Tenant",
	CON1_38: "Eform",
	CON1_37: "Loket",
	CON1_32: "Tenant",
	CON1_31: "Ubah Kategori",
	CON1_30: "Simpan",
	CON1_199: "Tambah Template Tema",
	CON1_198: "Jam",
	CON1_99: "Layanan tujuan transfer",
	CON1_193: "Semua survey",
	CON1_192: "Operator",
	CON1_191: "Laporan Survey",
	CON1_190: "Laporan No Show",
	CON1_197: "Aktor",
	CON1_196: "User",
	CON1_195: "Laporan Audit Trail",
	CON1_194: "Data tidak ditemukan",
	CON1_189: "Semua Sub Layanan",
	CON1_188: "Laporan File E-form",
	CON1_187: "Laporan Durasi Menunggu",
	CON1_90: "Mode Suara",
	CON1_94: "Tambah Layanan",
	CON1_93: "SLA (detik)",
	CON1_92: "Master Layanan",
	CON1_91: "Ubah display",
	CON1_98: "Semua cabang",
	CON1_97: "Tambah sub",
	CON1_96: "sub layanan",
	CON1_95: "Nama Layanan",
	CON1_89: "Pilih layanan",
	CON1_88: "Tambah display",
	CON1_182: "Tipe",
	CON1_181: "Semua Layanan",
	CON1_180: "Laporan Durasi Layanan",
	CON1_186: "There are no records to display",
	CON1_185: "Ekspor Excel",
	CON1_184: "Ekspor Csv",
	CON1_183: "Detail",
	CON1_179: "Reset",
	CON1_178: "Tidak Aktif (note: status booking hari ini di reset menjadi book)",
	CON1_299: "Sub layanan sudah ada.",
	CON1_177: "Pilih cabang",
	CON1_298: "Nama layanan harus diisi minimal 3 karakter.",
	CON1_176: "Pilih Tenant",
	CON1_297: "Nama Sub Layanan",
	CON1_83: "Quarter",
	CON1_82: "Half",
	CON1_81: "Hour",
	CON1_80: "Internal limit",
	CON1_87: "Status",
	CON1_86: "Keterangan",
	CON1_85: "Kode",
	CON1_84: "Master Display",
	CON1_79: "Edit interval limit",
	CON1_78: "Pilih Shift",
	CON1_77: "Shift",
	CON1_171: "Tambah Kepuasan",
	CON1_292: "Tidak",
	CON1_170: "Aktif & Tidak Aktif",
	CON1_291: "Ya, Lanjutkan",
	CON1_290: "Perhatian!",
	CON1_175: "Parameter Reset Antrian",
	CON1_296: "Shift harus dipilih.",
	CON1_174: "Ubah Kepuasan",
	CON1_295: "Hari harus dipilih.",
	CON1_173: "Alasan Penilaian",
	CON1_294: "Interval Limit Successfully Updated",
	CON1_172: "Semua",
	CON1_293: "Sukses!",
	CON1_168: "Bintang",
	CON1_289: "Apakah Anda yakin akan menghapus data tersebut?",
	CON1_167: "Parameter kepuasan",
	CON1_288: "Klik hari pada jadwal untuk melihat daftar limit perjam.",
	CON1_166: "Ubah Video",
	CON1_287: "note: status booking hari ini di reset menjadi book",
	CON1_165: "Tambah video",
	CON1_286: "Klik disini",
	CON1_169: "Alasan",
	CON1_72: "Ubah Jadwal Layanan",
	CON1_71: "Ubah Interval",
	CON1_70: "Ubah Limit",
	CON1_76: "Pilih Hari",
	CON1_75: "Hari",
	CON1_74: "Hapus Shift",
	CON1_73: "Tambah Shift",
	CON1_160: "Hari Libur Nasional",
	CON1_281: "Beli",
	CON1_280: "Jual",
	CON1_164: "Parameter Video",
	CON1_285: "Info pendaftaran?",
	CON1_163: "Ubah Hari Libur Nasional",
	CON1_284: "Deskripsi",
	CON1_162: "Tambah Hari Libur Nasional",
	CON1_283: "Review Timeout (detik)",
	CON1_161: "Tanggal",
	CON1_282: "Bank Notes",
	CON1_157: "Version",
	CON1_278: "Mata Uang",
	CON1_156: "Tambah aplikasi",
	CON1_277: "Trigger Url",
	CON1_155: "Tidak ada data untuk ditampilkan",
	CON1_276: "Get Url",
	CON1_154: "Parameter Aplikasi",
	CON1_275: "Valas",
	CON1_159: "Platform",
	CON1_158: "Changelog",
	CON1_279: "TT Counter",
	CON1_270: "Produk Item",
	CON1_153: "Ubah Banner/Image",
	CON1_274: "Drag untuk urutkan",
	CON1_152: "Tambah banner/image",
	CON1_273:
		"Masukkan angka antara 0 dan 100. Jika desimal, gunakan titik (.) sebagai pemisah. Contoh: 3.5",
	CON1_151: "Tidak Aktif & Aktif",
	CON1_272: "Nama Produk Item",
	CON1_150: "Parameter Banner/Image",
	CON1_271: "Persentase",
	CON1_146: "Isi",
	CON1_267: "Produk dan Suku Bunga",
	CON1_145: "Parameter Running Text",
	CON1_266: "Langsung Print",
	CON1_144: "Maksimal Karakter",
	CON1_265: "E-form",
	CON1_143: "Minimal Karakter",
	CON1_264: "Cetak",
	CON1_149: "Ubah Running Text",
	CON1_148: "Isi Running Text",
	CON1_269: "Kembali",
	CON1_147: "Tambah Running Text",
	CON1_268: "Nama Produk",
	CON1_380: "Total Layanan Non Aktif",
	CON1_384: "Parameter Panduan",
	CON1_142: "Ubah Eform",
	CON1_263: "Aplikasi konfigurasi sistem antrian",
	CON1_141: "Pesan Validasi",
	CON1_262: "Selamat Datang di Dashboard Konfigurasi Sistem Antrian",
	CON1_383: "Loket harus dipilih",
	CON1_140: "Field",
	CON1_261: "Panduan",
	CON1_382: "Konfigurasi Sistem Antrian iQue Cloud",
	CON1_260: "Fail",
	CON1_381: "Total Display",
	CON1_135: "Tipe Input",
	CON1_256: "Cabang Berhasil Diubah",
	CON1_2: "Masukan nama pengguna",
	CON1_377: "Total Loket",
	CON1_134: "Placeholder",
	CON1_255: "Edit Kriteria Penilaian",
	CON1_3: "Masuk",
	CON1_376: "Total Cabang",
	CON1_133: "Tambah Eform",
	CON1_254: "4. Tempelkan tautan yang sudah disalin pada input diatas",
	CON1_375: "Home",
	CON1_132: "Master Eform",
	CON1_253: "3. Salin tautan bagikan src. Contoh :",
	CON1_1: "Selamat datang di ique cloud",
	CON1_374: "Total Display",
	CON1_139: "Regex",
	CON1_6: "Cabang",
	CON1_138: "Non-required",
	CON1_259: "Success",
	CON1_7: "Tampilkan",
	CON1_137: "Required",
	CON1_258: "Nama File",
	CON1_4: "Info pendaftaran? Klik disini",
	CON1_379: "Total User",
	CON1_136: "Mandatory",
	CON1_257: "Backup & Restore",
	CON1_5: "Dashboard",
	CON1_378: "Total Layanan",
	CON1_8: "Tekan tampilkan untuk melihat data",
	CON1_9: "Beranda",
	CON1_131: "Ubah Loket",
	CON1_252: "2. Tekan tombol share/bagikan lalu pilih via Embed",
	CON1_373: "Total Layanan Non Aktif",
	CON1_130: "Nama Loket",
	CON1_251: "1. Buka video pada youtube yang akan disematkan",
	CON1_372: "Total User",
	CON1_250: "Cara",
	CON1_371: "Total Layanan",
	CON1_370: "Total Loket",
	CON1_124: "Ubah User Layanan",
	CON1_245: "Konfigurasi",
	CON1_366: "Parameter Suara",
	CON1_123: "Master User Layanan",
	CON1_244: "Logout",
	CON1_365: "Download panduan pengguna",
	CON1_122: "Pilih",
	CON1_243: "Ubah Profile",
	CON1_364: "Download panduan parameter running text",
	CON1_121: "Cabang\n Pilih",
	CON1_242: "Ubah Pengguna",
	CON1_363: "Download panduan konfigurasi",
	CON1_128: "Suara Pemanggil",
	CON1_249: "Sematkan tautan video",
	CON1_127: "Master Loket",
	CON1_248: "Biasa",
	CON1_369: "Total Cabang",
	CON1_126: "Ubah Loket Layanan Cabang",
	CON1_247: "Dieja",
	CON1_368: "iQue Cloud",
	CON1_125: "Master Loket Layanan Cabang",
	CON1_246: "Default",
	CON1_367: "Selamat Datang di",
	CON1_129: "Tambah Loket",
};
export const libCaller = {
	CAL1_43: "Info pendaftaran?",
	CAL1_42: "Antrian Siap Dipanggil",
	CAL1_41: "Skip",
	CAL1_40: "Ditunda",
	CAL1_47: "Belum Dipanggil",
	CAL1_46: "Kami sangat senang atas penilaian anda",
	CAL1_45: "Terima Kasih",
	CAL1_44: "Klik disini",
	CAL1_39: "Belum Tervalidasi",
	CAL1_38: "Sudah Dipanggil",
	CAL1_37: "Belum Check In",
	CAL1_32: "Pelayanan Petugas",
	CAL1_31: "Add New Transaction",
	CAL1_30: "Edit",
	CAL1_36: "Terima Kasih\nKami sangat senang atas penilaian anda",
	CAL1_35: "Kirim",
	CAL1_34: "Batal",
	CAL1_33: "Ruangan Bank",
	CAL1_7: "Pilih",
	CAL1_29: "Name display",
	CAL1_6: "Loket",
	CAL1_28: "Masukkan password",
	CAL1_5: "Info pendaftaran? Klik disini",
	CAL1_27: "Password",
	CAL1_4: "Masuk",
	CAL1_26: "Username",
	CAL1_9: "Waiting List",
	CAL1_8: "Silahkan memilih layanan",
	CAL1_3: "Masukan kata sandi",
	CAL1_2: "Masukan nama pengguna",
	CAL1_1: "Caller",
	CAL1_61: "Sedang Dilayani",
	CAL1_60: "Harap Selesaikan Antrian",
	CAL1_21: "Finish",
	CAL1_20: "Transfer",
	CAL1_64: "Pemanggilan Sistem Antrian iQue Cloud",
	CAL1_63: "Sukses...!!!",
	CAL1_62: "Informasi Customer",
	CAL1_25: "Profile",
	CAL1_24: "New Transaction",
	CAL1_23: "Lihat E-form",
	CAL1_22: "Riwayat",
	CAL1_18: "Serve",
	CAL1_17: "Call",
	CAL1_16: "Jam mulai transaksi",
	CAL1_15: "Standar durasi",
	CAL1_59: "Simpan",
	CAL1_19: "Hold",
	CAL1_50: "Sedang Memanggil",
	CAL1_10: "Durasi",
	CAL1_54: "Masukkan Name Display",
	CAL1_53: "File E-Form",
	CAL1_52: "Nomor Antrian:",
	CAL1_51: "Informasi E-Form",
	CAL1_14: "Jumlah transaksi",
	CAL1_58: "Antrian Berhasiil di transfer",
	CAL1_13: "Catatan",
	CAL1_57: "Kode Display",
	CAL1_12: "Total",
	CAL1_56: "Tidak ada notifikasi",
	CAL1_11: "Lihat Daftar",
	CAL1_55: "Notifikasi",
	CAL1_49: "Antrian",
	CAL1_48: "Daftar Kosong",
};

export const libMonitoring = {
	MON1_21: "Data Kosong",
	MON1_10: "Antrian Saat Ini",
	MON1_20: "Nama Pengguna",
	MON1_12: "Riwayat",
	MON1_11: "Durasi",
	MON1_14: "Status",
	MON1_13: "Keterangan",
	MON1_16: "Tidak Aktif",
	MON1_15: "Terakhir Update",
	MON1_18: "Jenis Pemanggilan",
	MON1_17: "Aktif",
	MON1_19: "Semua",
	MON1_1: "Monitoring Sistem Antrian iQue Cloud",
	MON1_4: "Masuk",
	MON1_5: "Loket",
	MON1_2: "Monitoring",
	MON1_3: "Masukkan kode cabang",
	MON1_8: "Layanan",
	MON1_9: "Semua Loket",
	MON1_6: "Hardware",
	MON1_7: "Pemanggilan",
};